/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseAccountInformationType
 */
export interface CaseAccountInformationType {
    /**
     * 
     * @type {string}
     * @memberof CaseAccountInformationType
     */
    account?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAccountInformationType
     */
    portfolio?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CaseAccountInformationType
     */
    isRequiredNewBr?: boolean;
}

/**
 * Check if a given object implements the CaseAccountInformationType interface.
 */
export function instanceOfCaseAccountInformationType(value: object): value is CaseAccountInformationType {
    return true;
}

export function CaseAccountInformationTypeFromJSON(json: any): CaseAccountInformationType {
    return CaseAccountInformationTypeFromJSONTyped(json, false);
}

export function CaseAccountInformationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseAccountInformationType {
    if (json == null) {
        return json;
    }
    return {
        
        'account': json['account'] == null ? undefined : json['account'],
        'portfolio': json['portfolio'] == null ? undefined : json['portfolio'],
        'isRequiredNewBr': json['isRequiredNewBr'] == null ? undefined : json['isRequiredNewBr'],
    };
}

export function CaseAccountInformationTypeToJSON(json: any): CaseAccountInformationType {
    return CaseAccountInformationTypeToJSONTyped(json, false);
}

export function CaseAccountInformationTypeToJSONTyped(value?: CaseAccountInformationType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account': value['account'],
        'portfolio': value['portfolio'],
        'isRequiredNewBr': value['isRequiredNewBr'],
    };
}

